import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withModifiers as _withModifiers, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal modal-sm has-alert",
  id: "modal-saveSearch"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = {
  key: 0,
  class: "modal-alert alert-save"
}
const _hoisted_4 = { class: "modal-alert-text" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-close" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-header" }
const _hoisted_9 = { class: "modal-title" }
const _hoisted_10 = { class: "modal-content" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "form-body" }, [
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_12 = { class: "form-footer is-inline nowrap" }
const _hoisted_13 = {
  key: 0,
  class: "form-messages"
}
const _hoisted_14 = {
  key: 0,
  class: "flashmessage flash-danger"
}
const _hoisted_15 = { class: "form-body" }
const _hoisted_16 = {
  key: 0,
  class: "form-field"
}
const _hoisted_17 = { class: "checkbox" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_19 = { class: "form-field" }
const _hoisted_20 = { for: "frm-saveSearchForm_email" }
const _hoisted_21 = ["value"]
const _hoisted_22 = { for: "frm-saveSearchForm_title" }
const _hoisted_23 = {
  key: 0,
  class: "form-error"
}
const _hoisted_24 = { class: "form-field" }
const _hoisted_25 = { for: "frm-saveSearchForm_frequency" }
const _hoisted_26 = { class: "selectbox" }
const _hoisted_27 = ["value"]
const _hoisted_28 = {
  key: 0,
  class: "form-error"
}
const _hoisted_29 = { class: "form-footer is-inline nowrap" }
const _hoisted_30 = {
  key: 0,
  href: "#",
  class: "button button--primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "modal-fade",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isSuccess)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('AdFilter.success-message')), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: "modal-close",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
            }, _hoisted_7),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('AdFilter.title')), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('AdFilter.subtitle')), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("form", {
                id: "saveSearchForm-form",
                class: "form",
                onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)), ["prevent"])),
                autocomplete: "off"
              }, [
                (_ctx.isSuccess)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_11,
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_router_link, {
                          tag: "button",
                          to: { name: 'AdFilterList' },
                          class: "button button--primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('AdFilter.button-my-filters')), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.showFormMessages)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (_ctx.isError)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('forms.required-fields')), 1))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "flashmessage flash-danger"
                              }, _toDisplayString(error), 1))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_15, [
                        (_ctx.isEdit)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createElementVNode("label", _hoisted_17, [
                                _createTextVNode(_toDisplayString(_ctx.$t('AdFilter.new-filter')) + " ", 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.createNew) = $event))
                                }, null, 512), [
                                  [_vModelCheckbox, _ctx.createNew]
                                ]),
                                _hoisted_18
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('AdFilter.email')) + ":", 1),
                          _createElementVNode("input", {
                            type: "text",
                            id: "frm-saveSearchForm_email",
                            readonly: "",
                            value: _ctx.user.email,
                            name: "email",
                            class: "form-control"
                          }, null, 8, _hoisted_21)
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.title.$error }])
                        }, [
                          _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('AdFilter.filter-title')) + ":", 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.form.title.$model) = $event)),
                            name: "frm-complaintForm_title",
                            class: "form-control"
                          }, null, 512), [
                            [_vModelText, _ctx.v$.form.title.$model]
                          ]),
                          (_ctx.v$.form.title.$dirty && _ctx.v$.form.title.$invalid)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.v$.form.title.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t('forms.required')), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('AdFilter.frequency')) + ":", 1),
                          _createElementVNode("div", _hoisted_26, [
                            _withDirectives(_createElementVNode("select", {
                              class: "form-control",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.form.frequency.$model) = $event))
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.frequencies, (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: item.key,
                                  key: item.key
                                }, _toDisplayString(item.value), 9, _hoisted_27))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.v$.form.frequency.$model]
                            ])
                          ]),
                          (_ctx.v$.form.frequency.$dirty && _ctx.v$.form.frequency.$invalid)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.v$.form.frequency.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('forms.required')), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_router_link, { to: { name: 'AdFilterList' } }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('AdFilter.button-my-filters')), 1)
                          ]),
                          _: 1
                        }),
                        (!_ctx.isSuccess)
                          ? (_openBlock(), _createElementBlock("button", _hoisted_30, _toDisplayString(_ctx.$t('AdFilter.button-save')), 1))
                          : _createCommentVNode("", true)
                      ])
                    ], 64))
              ], 32)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}